export type QuickStartTutorialType = 'quick-start' | 'field-explanation';

let pendingRequest: QuickStartTutorialType | null = null;
const listeners = new Set<() => void>();

export function requestQuickStartTutorial(type: QuickStartTutorialType) {
  pendingRequest = type;
  listeners.forEach((listener) => {
    listener();
  });
}

export function consumeQuickStartTutorialRequest() {
  const request = pendingRequest;
  pendingRequest = null;
  return request;
}

export function subscribeQuickStartTutorialRequest(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
